<template>
  <ConfigProvider :locale="getAntdLocale" component-size="small">
    <AppProvider>
      <RouterView />
    </AppProvider>
  </ConfigProvider>
</template>

<script lang="ts" setup>
  import { ConfigProvider } from 'ant-design-vue';
  import { AppProvider } from '/@/components/Application';
  import { useTitle } from '/@/hooks/web/useTitle';
  import { useLocale } from '/@/locales/useLocale';
  // import { themeOverrides } from '/@/screen/styles/themes/naive-ui-theme-overrides';
  // support Multi-language
  const { getAntdLocale } = useLocale();
  import dayjs from 'dayjs';
  import 'dayjs/locale/zh-cn';
  import quarterOfYear from 'dayjs/plugin/quarterOfYear';

  dayjs.locale('zh-cn');
  dayjs.extend(quarterOfYear);
  useTitle();
</script>
